import { gql } from 'urql';

const FetchPresignedCheckDepositImageUpload = gql`
  query FetchPresignedCheckDepositImageUpload {
    presignedUpload(count: 2) {
      id
      uploadUrl
      file
      method
      form {
        name
        value
      }
    }
  }
`;
export default FetchPresignedCheckDepositImageUpload;
